import { useMemo } from 'react';
import { connect } from 'react-redux';
import { Button, Box } from '@mui/material';
import { useMaterialReactTable, MaterialReactTable } from 'material-react-table';
import { arraysEqual } from '../../../../utils/collections';
import { tableSelectionOptions, defaultTableOptions } from '../../../util/data-table';
import { equipmentColumns, equipmentNameId, equipmentTypeId } from '../../columns';
import { createContains, deleteContains } from '../../../../redux/actions/buildings';

const ContainsEquipment = ({
  stagingEquipment,
  loc,

  equipmentTypes,
  containsCreate,
  containsDelete,
}) => {
  const columns = useMemo(() => equipmentColumns(false, equipmentTypes), [equipmentTypes]);
  const data = useMemo(
    // Default order selected first
    () =>
      stagingEquipment
        .filter((e) => Boolean(e.published))
        .sort((a, b) => {
          if (a.published?.containsLocations?.includes(loc.name)) {
            if (b.published?.containsLocations?.includes(loc.name)) {
              return a.id < b.id;
            }
            return -1;
          }
          if (b.published?.containsLocations?.includes(loc.name)) return 1;
          return a.id < b.id;
        }),
    [stagingEquipment, loc]
  );

  const mrt = useMaterialReactTable({
    ...defaultTableOptions,
    ...tableSelectionOptions,
    columns,
    data,
    initialState: {
      columnVisibility: Object.fromEntries(
        columns
          .map((c) => c.id)
          .filter((id) => ![equipmentNameId, equipmentTypeId].includes(id))
          .map((id) => [id, false])
      ),
      rowSelection: Object.fromEntries(loc.containsEquipment.map((id) => [id, true])),
    },
    getRowId: (e) => e.published.id,
    renderTopToolbarCustomActions: ({ table }) => {
      const handleApply = () => {
        const selectedIds = table
          .getSelectedRowModel()
          .flatRows.map(({ original }) => original.published.id);
        function handleRemove() {
          const equipmentToRemove = loc.containsEquipment.filter((l) => !selectedIds.includes(l));
          if (equipmentToRemove.length > 0) return containsDelete(equipmentToRemove);
          return Promise.resolve();
        }
        function handleAdd() {
          const equipmentToAdd = selectedIds.filter((l) => !loc.containsEquipment.includes(l));
          if (equipmentToAdd.length > 0) return containsCreate(equipmentToAdd);
          return Promise.resolve();
        }
        return handleRemove().then(() => handleAdd());
      };

      return (
        <Box sx={{ display: 'flex', gap: '0.5rem' }}>
          <Button
            color="success"
            disabled={arraysEqual(
              table
                .getSelectedRowModel()
                .flatRows.map(({ original }) => original.published.id)
                .toSorted(),
              loc.containsEquipment
            )}
            onClick={handleApply}
            variant="contained"
          >
            Apply Selection
          </Button>
        </Box>
      );
    },
  });
  return <MaterialReactTable table={mrt} />;
};

function mapStateToProps(state) {
  const {
    entities: { equipTypes },
  } = state;
  return {
    equipmentTypes: equipTypes.byId,
  };
}

function mapDispatchToProps(dispatch, { loc, building }) {
  return {
    containsCreate: (newContainsEquipment) =>
      dispatch(createContains(building.id, loc.name, [], newContainsEquipment)),
    containsDelete: (containsEquipmentToRemove) =>
      dispatch(deleteContains(building.id, loc.name, [], containsEquipmentToRemove)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ContainsEquipment);
